import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import p_conferma from "../assets/images/p_conferma.png";
import avatar1 from "../assets/images/avatar01.png";
import avatar2 from "../assets/images/avatar02.png";
import avatar3 from "../assets/images/avatar03.png";
import avatar4 from "../assets/images/avatar04.png";
import avatar5 from "../assets/images/avatar05.png";
import avatar6 from "../assets/images/avatar06.png";
import avatar7 from "../assets/images/avatar07.png";
import avatar8 from "../assets/images/avatar08.png";

import popup_1_1 from "../assets/images/popup_1_1.png";
import popup_4_2 from "../assets/images/popup_4_2.png";

// Map degli avatar in base al nome
const avatarMap = {
    avatar01: avatar1,
    avatar02: avatar2,
    avatar03: avatar3,
    avatar04: avatar4,
    avatar05: avatar5,
    avatar06: avatar6,
    avatar07: avatar7,
    avatar08: avatar8,
};

const IpadDomanda4 = () => {
    const navigate = useNavigate();
    const location = useLocation();


    const { casoClinico, userId, gameId } = location.state || {};

    const [utenteInfo, setUtenteInfo] = useState({ avatar: '', nickname: '', npunti: 0 });
    const [domandaCorrente, setDomandaCorrente] = useState(0);
    const [domande, setDomande] = useState([]);
    const [risposte, setRisposte] = useState([]);
    const [punteggio, setPunteggio] = useState(0);
    const [rispostaSelezionata, setRispostaSelezionata] = useState('');
    const [rispostaDomanda1, setRispostaDomanda1] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupImage, setPopupImage] = useState('');
    const [playerField, setPlayerField] = useState('');


    // Recupera le informazioni dell'utente all'inizio
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/utente/info`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userid: userId })  // Invia lo userid al backend
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Errore nel recupero delle informazioni utente');
                }
                return res.json();
            })
            .then((data) => {
                setUtenteInfo({ avatar: data.avatar, nickname: data.nickname, npunti: data.npunti });
                setPunteggio(data.npunti );
            })
            .catch((error) => {
                console.error('Errore nel recupero delle informazioni utente:', error);
            });
    }, [userId]);

    // Recupera le domande dal database al caricamento della pagina
    useEffect(() => {

        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/casoclinico/domande`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_caso_clinico: casoClinico })  // Invia l'ID del caso clinico
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Errore nel recupero delle domande');
                }
                return res.json();
            })
            .then((data) => {
                setDomande(data);
                setRisposte(data[0].risposte);  // Imposta le risposte della prima domanda

            })
            .catch((error) => {
                console.error('Errore nel recupero delle domande:', error);
            });
    }, [casoClinico]);

    useEffect(() => {
        // Determina quale campo aggiornare per il giocatore
        const fetchPlayerField = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-players`, { params: { gameId } });
                const { fkidplayer1, fkidplayer2 } = response.data;

                // Determina se il giocatore corrente è player1 o player2
                if (userId === fkidplayer1) {
                    setPlayerField('monitor_player1');
                } else if (userId === fkidplayer2) {
                    setPlayerField('monitor_player2');
                } else {
                    console.error("Errore: userId non corrisponde a nessun giocatore.");
                }
            } catch (error) {
                console.error("Errore nel recupero delle informazioni dei giocatori:", error);
            }
        };

        fetchPlayerField();
    }, [gameId, userId]);


    // Aggiorna lo stato del giocatore nel database
    const updatePlayerState = async (nextState) => {
        if (!playerField) return;

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state-bis`, {
                gameId,
                playerField,
                state: nextState
            });
            console.log(`Stato aggiornato per ${playerField}: ${nextState}`);
        } catch (error) {
            console.error("Errore nell'aggiornamento dello stato del monitor:", error);
        }
    };

    // Funzione per aggiornare lo stato del monitor OLD
    const updateMonitorState = async (state) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update-monitor-state`, {
                gameId: gameId,
                monitor: state
            });
        } catch (error) {
            console.error("Errore durante l'aggiornamento dello stato del monitor:", error);
        }
    };

    useEffect(() => {
        updateMonitorState(`domanda_4_${domandaCorrente}`);
    }, [domandaCorrente]);

    useEffect(() => {
        updateMonitorState(`domanda_4_${domandaCorrente}`);
        if (playerField) {
            updatePlayerState(`domanda_4_${domandaCorrente}`);
        }
    }, [playerField, gameId, domandaCorrente]);

    const handleRispostaNumerica = (e) => {
        //la idrisposta è il valore inserito
        setRispostaSelezionata(e.target.value);
    };


    const handleConfermaRisposta = () => {
        if (!rispostaSelezionata) {
            alert('Devi selezionare una risposta!');
            return;
        }

        let punteggioDomanda = 0; // Valore di default per il punteggio

        if (domandaCorrente === 0) {
            const risposta = risposte.find((r) => r.id === rispostaSelezionata);
            setRispostaDomanda1(rispostaSelezionata);
            punteggioDomanda = risposta ? risposta.punteggio : 0;

            // Mostra il popup prima di andare alla domanda 2
            setPopupImage(popup_1_1);
            setShowPopup(true);
        }
        // Se siamo alla seconda domanda (indice 1), confronta la risposta numerica
        else if (domandaCorrente === 1) {
            //100 punti: RS corretto
            //80 punti: +5 o -5
            //60 punti: +10 o -10
            //40 punti: +12 o -12

            const rispostaNumerica = Number(rispostaSelezionata);

            //RS CORRETTO
            if(rispostaNumerica ===20){
                punteggioDomanda =100;
            } else if (rispostaNumerica>=-5 && rispostaNumerica<=5) {
                punteggioDomanda =80;
            } else if (rispostaNumerica>=-10 && rispostaNumerica<=10) {
                punteggioDomanda =60;
            } else if (rispostaNumerica>=-12 && rispostaNumerica<=12) {
                punteggioDomanda =40;
            }

            // Mostra il popup anche dopo la seconda domanda
            setPopupImage(popup_4_2);

            updateMonitorState("risp_4_1");
            updatePlayerState("risp_4_1");
            setTimeout(() => {
                updateMonitorState("risp_4_2");
                updatePlayerState("risp_4_2");
            }, 10000); // 10000 ms = 10 secondi

            setShowPopup(true);


        } else {
            // Gestisce il punteggio per le altre domande
            const risposta = risposte.find((r) => r.id === rispostaSelezionata);
            punteggioDomanda = risposta ? risposta.punteggio : 0;
        }

        // Aggiorna il punteggio complessivo e lo mostra subito
        const nuovoPunteggio = punteggio + punteggioDomanda;
        setPunteggio(nuovoPunteggio);

        // Invia la risposta al backend
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/salva-risposta`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idutente: userId,
                iddomanda: domande[domandaCorrente].id,
                idrisposta: rispostaSelezionata,
                punteggio: punteggioDomanda
            })
        }).then((res) => {

            if (res.ok && domandaCorrente >= domande.length - 2) {

                // Se tutte le domande sono state risposte, vai alla pagina di fine caso
                if (domandaCorrente >= domande.length - 2) {
                     navigate('/ipad/cover-cc-5', { state: { casoClinico:5, userId, gameId } });
                } else {
                    // Altrimenti passa alla domanda successiva
                    handleNextQuestion();
                }

            }
        });


    };

    // Funzione per chiudere il popup e passare alla domanda successiva
    const handleClosePopup = () => {
        setShowPopup(false);

        // Logica per passare alla domanda 2 dopo il popup
        if (domandaCorrente === 0) {
            setDomandaCorrente(1); // Passa alla domanda 2
            setRisposte(domande[1].risposte);
        }
        // Dopo il secondo popup, passa alla terza o quarta domanda in base alla risposta alla prima domanda
        else if (domandaCorrente === 1) {
            handleNextQuestion();
        }
        setRispostaSelezionata(''); // Resetta la selezione
    };



    // Funzione per passare dalla domanda 2 alla domanda 3 o 4 in base alla risposta alla domanda 1
    const handleNextQuestion = () => {
        let prossimaDomanda = domandaCorrente + 1;


        if (domandaCorrente === 1) {
            if (rispostaDomanda1 === domande[0].risposte[0].id || rispostaDomanda1 ===domande[0].risposte[1].id || rispostaDomanda1 ===domande[0].risposte[3].id) {
                prossimaDomanda = 2; // Va alla domanda 3
            } else if (rispostaDomanda1 === domande[0].risposte[2].id) {
                prossimaDomanda = 3; // Va alla domanda 4
            }
        }

        setDomandaCorrente(prossimaDomanda);
        setRisposte(domande[prossimaDomanda].risposte);
        setRispostaSelezionata(''); // Resetta la selezione
    };




    if (domande.length === 0) {
        return <div>Caricamento domande...</div>;
    }
    const domandaAttuale = domande[domandaCorrente];

    return (
        <div
            className="ipad_domanda_4 flex flex-col w-full h-full  items-center justify-center relative bg-fixed overflow-hidden" >
            {/* Testo della domanda */}
            <h2 className={`text-3xl font-bold mb-6 mx-8 text-orange ${showPopup ? 'opacity-0' :'' }`} >{domandaAttuale.testo_domanda}</h2>
            {/* Opzioni di risposta */}
            <div className="bg-black p-8 rounded-3xl shadow-md w-[840px] h-auto  relative opacity-80">
                <div className="flex flex-col  space-y-4 ">

                    {domandaCorrente === 1 ? (
                        // Mostra textbox per risposte numeriche
                        <div className="flex items-center space-x-4 justify-center" style={{border: '0px solid red'}}>
                            <input
                                type="text"
                                value={rispostaSelezionata}
                                onChange={handleRispostaNumerica}
                                className="w-[250px] h-[80px] p-2 border rounded-lg text-3xl text-orange items-center justify-center"
                                placeholder=""
                                maxLength={3}
                            />
                        </div>
                    ) : (
                        // Caso normale con risposte multiple
                        domandaAttuale.risposte.map((risposta) => (
                            <div key={risposta.id} className="flex items-center space-x-4">
                                <input
                                    type="checkbox"
                                    id={`checkbox-${risposta.id}`}
                                    className="hidden peer"
                                    checked={rispostaSelezionata === risposta.id}
                                    onChange={() => setRispostaSelezionata(risposta.id)}
                                />
                                <label
                                    htmlFor={`checkbox-${risposta.id}`}
                                    className="w-8 h-8 border-2 border-gray-400 rounded-full cursor-pointer peer-checked:bg-green-500 flex items-center justify-center"
                                    style={{width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        minWidth: '30px',
                                    }} >
                                    {rispostaSelezionata === risposta.id && <span className="text-white">✓</span>}
                                </label>
                                <span className="text-2xl text-white">{risposta.testo_risposta}</span>
                            </div>
                        ))
                    )}
                </div>

                <br/><br/>

                <div className="flex justify-center mt-8 items-end justify-end">
                    <button onClick={handleConfermaRisposta}>
                        <img
                            src={p_conferma} // Percorso dell'immagine del pulsante
                            alt="Conferma"
                            className="w-[225px] h-auto items-end justify-end"
                        />
                    </button>
                </div>
            </div>

            {/* Popup che appare dopo la risposta alla domanda 1 */}
            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center " >
                    <div className="p-1 pb-0" style={{border: '0px solid red'}}>
                        <br/><br/>
                        {/* Immagine nel popup */}
                        <img
                            src={popupImage}
                            alt="Popup"
                            className="cursor-pointer"
                            onClick={handleClosePopup}
                        />
                    </div>
                </div>
            )}

            {/* Avatar e nickname in basso a sinistra */}
            <div className="absolute bottom-4 left-4 flex items-center space-x-4">
                <img src={avatarMap[utenteInfo.avatar]} alt="Avatar" className="w-12 h-12 rounded-full"/>
                <span className="text-2xl font-bold text-verde">{utenteInfo.nickname}</span>
                </div>

                {/* Punteggio in basso a destra */}
                <div className="absolute bottom-4 right-4 text-2xl font-bold text-verde">
                    Your score:  {punteggio}
                </div>
            </div>
    );
};

export default IpadDomanda4;
